module.exports = __webpack_public_path__ + "static/media/montserrat-v15-latin-ext_latin_cyrillic-ext_cyrillic-regular.7bf99c00.woff";